import { WriteOffLineItem } from '@posModels';

export function writeOffAmountCents(item: WriteOffLineItem, qty: number): number {
  return Math.min(qty * item.unitPriceCents, item.outstandingCents);
}

export function isPartlyPaid(item: WriteOffLineItem): boolean {
  return item.outstandingCents < item.availableQty * item.unitPriceCents;
}
